// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .push-right {
    margin-left: auto;
    margin-bottom: 7px;
  }
  .date-picker-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  
  .custom-date-picker {
    margin-left: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/dashboard/Justices/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .push-right {\n    margin-left: auto;\n    margin-bottom: 7px;\n  }\n  .date-picker-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n  }\n  \n  .custom-date-picker {\n    margin-left: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
